<template>
  <div
    class='overflow-auto'
    style='height: calc(100vh - 300px);'>
    <table class='text-sm table-fixed'
      id='excelIpos'>
      <thead>
        <tr>
          <table-header-filter-select
            v-bind:filter-texts.sync='filterTexts.report_name'
            keyName='report_name'
            v-bind:sorting-dir.sync='sortDir'
            v-bind:sorting-key.sync='sortKey'
            defaultLabel='보고서명'
            :optionObject='corporateAnnouncements'
            class='text-left' />
          <table-header-filter-select
            v-bind:filter-texts.sync='filterTexts.share_code'
            keyName='share_code'
            v-bind:sorting-dir.sync='sortDir'
            v-bind:sorting-key.sync='sortKey'
            defaultLabel='종목코드'
            :optionObject='corporateAnnouncements'
            class='text-left' />
          <table-header-filter-select
            v-bind:filter-texts.sync='filterTexts.name'
            keyName='name'
            v-bind:sorting-dir.sync='sortDir'
            v-bind:sorting-key.sync='sortKey'
            defaultLabel='종목'
            :optionObject='corporateAnnouncements'
            class='text-left' />
          <table-header-filter-select
            v-bind:filter-texts.sync='filterTexts.market'
            keyName='market'
            v-bind:sorting-dir.sync='sortDir'
            v-bind:sorting-key.sync='sortKey'
            defaultLabel='시장'
            :optionObject='corporateAnnouncements'
            class='text-left' />
          <th class='border-l'>진행상황</th>
          <th>시장구분</th>
          <th>상장공모</th>
          <th>총공모주식수</th>
          <th>액면가</th>
          <th>희망공모가액</th>
          <th>확정공모가</th>
          <th>주간사</th>
          <th>수요예측시작일</th>
          <th>수요예측종료일</th>
          <th>공모청약시작일</th>
          <th>공모청약종료일</th>
          <th>납입일</th>
          <th>환불일</th>
          <th>상장일</th>
          <th class='border-l'>Receipt Date</th>
          <th>Receipt Number</th>
        </tr>
      </thead>
      <tbody>
        <corporate-announcement-ipo-row
          v-for='corporateAnnouncement in filteredData'
          :key='`corporateAnnouncement-${corporateAnnouncement.id}`'
          :announcement='corporateAnnouncement' />
      </tbody>
    </table>
  </div>
</template>

<script>
import CorporateAnnouncementIpoRow from '@/views/corporate_announcements/CorporateAnnouncementIpoRow.vue'
import TableHeaderFilterSelect from '@/components/TableHeaderFilterSelect.vue'
import EventBus from '@/utils/event-bus'
import * as XLSX from 'xlsx-js-style'

export default {
  name: 'CorporateAnnouncementIpos',
  components: {
    CorporateAnnouncementIpoRow,
    TableHeaderFilterSelect,
  },
  props: [
    'corporateAnnouncements',
    'dateRange',
  ],
  data () {
    return {
      sortDir: '',
      sortKey: '',
      filterTexts: {
        report_name: [],
        share_code: [],
        name: [],
        market: [],
        action: [],
        corporate_method: [],
      },
      filterKeys: [
        'report_name',
        'share_code',
        'name',
        'market',
        'action',
        'corporate_method',
      ],
    }
  },
  computed: {
    sortedData () {
      if (this.sortDir === '') {
        return this.corporateAnnouncements
      } else {
        this.sortData ( this.corporateAnnouncements, {key: this.sortKey, direction: this.sortDir} )
        return this.corporateAnnouncements
      }
    },
    filteredData () {
      return this.sortedData.filter( data => this.inAnyData(data, this.filterKeys, this.filterTexts) )
    },
  },
  methods: {
    inAnyData (data, filterKeys, filters) {
      if (filterKeys) {
        for (var ii = 0; ii < filterKeys.length; ii++) {
          var key = filterKeys[ii]
          if (!this.inAny (data[key], filters[key]))
            return false
        }
      }
      return true
    },
    inAny (source, filterTexts) {
      if (!filterTexts || filterTexts.length === 0)
        return true

      for (var ii = 0; ii < filterTexts.length; ii++) {
        if (source == filterTexts[ii])
          return true
      }
      return false
    },
  },
  mounted () {
    EventBus.$on('downloadExcel', () => {
      var excelData = XLSX.utils.table_to_sheet(document.getElementById('excelIpos'))
      var workBook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workBook, excelData, '증권신고서')
      XLSX.writeFile(workBook, `증권신고서_${this.dateRange.start_date}_${this.dateRange.end_date}.xlsx`)
    })
  },
  beforeDestroy () {
    EventBus.$off('downloadExcel')
  },
}
</script>

<style lang='scss' scoped>
  th {
    @apply py-3 pl-2 pr-6 border-b text-left uppercase tracking-wide sticky top-0 whitespace-no-wrap;
  }

</style>
